import { render, staticRenderFns } from "./StatisticNoticeBox.vue?vue&type=template&id=8ee1dbc4&"
import script from "./StatisticNoticeBox.vue?vue&type=script&lang=ts&"
export * from "./StatisticNoticeBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports